import React from "react";
import { NavLink, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux'
import axios from 'axios'

import { payOut, payOutConfirm } from "../../actions/payOutActions";
import {getCurrentUserSuccess, addMoneyUser} from '../../actions/session';
import { activatePromocode } from '../../actions/promocodeActions';
import {whereBallsMove, getHeader, isSimilarObject, myToString} from "../../helper"

import PersonalData from './PersonalData'
import Balance from './Balance'
import Locations from './Locations'
import LocationCreate from './Locations/LocationCreate';
import PassportData from './PassportData'
import BlackList from './BlackList'
import Notificaions from './Notificaions'
import Settings from './Settings'
import SocialNetwork from './SocialNetwork'
import LeftNavContent from '../Commons/LeftNavContent';
import BlacklistModal from './BlackListModal';
import PromocodeModal from "./Modals/Promocode";
import CashInUserModal from "../Profile/Balance/CashInUserModal";
import CashOutUserModal from "../Profile/Balance/CashOutUserModal";

class Account extends React.Component {
    constructor(props) {
        super(props);

        const {session:{currentUser}} = props;        

        this.state = {
            orderList: {},

            removeBlacklistModal: {
                show: false,
                type: 'default',
                user: {},
                title: 'Удаление из черного списка',
                text: 'Вы действительно хотите удалить {user} из черного списка?'
            },

            activatePromo: {
                promocode: '',
                show: false,
                type: 'default',
                error: '',
            },

            putBalanceIndividual: {
                show: false,
                amount: 0,
                button: false,
                isFetching: false,
                type: 'default',
                html: ''
            },

            withdrawMoney: {
                show: false,
                amount: currentUser.balance_contractor,
                comission: 0,
                willWithdraw: 0,
                step: 1,
                code: '',
                isFetching: false,
                type: 'default',
                confirmData: null,
                payOutData: null,
                user_type: true,
            },
        }
    }

    componentDidMount() {
        whereBallsMove(6);
    }

    componentDidUpdate(prevProps, prevState) {
        const {data, session:{currentUser}} = this.props;
        const {withdrawMoney} = this.state;

        if(
            !isSimilarObject(prevProps.data['settings-tax'], data['settings-tax'])
        ) {
            this.cashOutHandleAmount(withdrawMoney.amount);
        }

        if(
            prevState.withdrawMoney.show !== withdrawMoney.show
        ) {
            this.setState({
                withdrawMoney: {
                    ...this.state.withdrawMoney,
                    amount: currentUser.balance_contractor,
                }
            }, () => this.cashOutHandleAmount(this.state.withdrawMoney.amount))
        }
        
        if(
            prevState.withdrawMoney.show !== withdrawMoney.show &&
            withdrawMoney.show
        ) {
            if(!this.state.orderList.results) {
                this.getOrderList();
            }
        }
    }

    getOrderList(next) {
        let fullUrl = `${window.siteUrl}/api/v1/order/contractor_not_pay_out/`;
        if(next) fullUrl = next;

        axios.get(fullUrl, {
            headers: getHeader()
        })
        .then(response => {
            if(!next) {
                this.setState({orderList: response.data});
                return;
            }

            this.setState({
                orderList: {
                    ...this.state.orderList,
                    ...response.data,
                    results: [
                        ...this.state.orderList.results,
                        ...response.data.results
                    ]
                }
            });
        })
        .catch(function (error) {
            console.error("get order list error", error);
        });
    }

    onModalClick(user) {
        this.setState({
            removeBlacklistModal: {
              ...this.state.removeBlacklistModal,
              user,
              show: true,
            }
        })
    }

    confirmRemove() {
        const user = this.state.removeBlacklistModal.user;
        axios.post(
            `${window.siteUrl}/api/v1/user/${user.id}/remove_from_blacklist/`,
            {},
            {
            headers: getHeader()
            }
        )
        .then(response => {
            const newBlacklist = this.props.session.currentUser.blacklist_users.filter(blUser => blUser.id !== user.id);
            const payload = {
            blacklist_users: newBlacklist
            }
            this.props.getCurrentUserSuccess(payload);
            this.setState({
            removeBlacklistModal: {
                ...this.state.removeBlacklistModal,
                type: 'success',
                text: '{user} удален из черного списка'
            }
            })
        })
        .catch(error => {
            console.error(error);
        })
    }

    closeRemove() {
        this.setState({
            removeBlacklistModal: {
            ...this.state.removeBlacklistModal,
            show: false,
            type: 'default'
            }
        })
    }

    onPromocodeClick(e) {
        e.preventDefault();
        this.setState({
            activatePromo: {
                ...this.state.activatePromo,
                show: true
            }
        })
    }

    promocodeConfirm() {
        this.props.activatePromocode({ promocode: this.state.activatePromo.promocode }, (res) => {
            if(res.status && res.status !== 200) {
                this.setState({
                    activatePromo: {
                        ...this.state.activatePromo,
                        type: 'error',
                        error: res.data.detail ? res.data.detail : res.data.non_field
                    }
                })
            } else {
                this.props.addMoneyUser({ price: res.data.sum });
                this.setState({
                    activatePromo: {
                        ...this.state.activatePromo,
                        type: 'success'
                    }
                });

                setTimeout(() => {
                    localStorage.setItem('change_balance', res.data.sum)
                }, 100);

            }
        })
    }

    handlePromocode(value) {
        this.setState({
            activatePromo:
            {
                ...this.state.activatePromo,
                promocode: value
            }
        })
    }

    promocodeClose() {
        this.setState({ 
            activatePromo: { 
                ...this.state.activatePromo,
                show: false,
                promocode: '',
                error: '',
                type: 'default'
            } 
        })
    }

    withdrawMoneyOpen() {
        const {session:{currentUser}} = this.props;

        this.setState({
            withdrawMoney:{
                ...this.state.withdrawMoney,
                fio: `${currentUser.first_name} ${currentUser.last_name} ${currentUser.patronymic_name}`,
                inn: currentUser.inn,
                show: true
            }
        });
    }

    cashOutHandleAmount(value) {
        const {currentUser} = this.props.session;
        const {withdrawMoney:{user_type}} = this.state;
        let {
            payout_tax_percent,
            payout_tax_min,
            payout_self_employed_tax_percent,
            payout_self_employed_tax_min
        } = this.props.data['settings-tax'];

        const amount = parseFloat(value);
        let newState = 0;
        let willWithdraw = 0;
        let comission = 0;
        let balance = parseFloat(currentUser.balance_contractor);
        let minNdflText;

        if(amount > 0) {
            newState = (amount > balance) ? balance : amount;
        }

        //Расчет комиссии
        if(amount && payout_tax_percent) {
            comission = Math.floor(newState*payout_tax_percent)/100;
        }

        if(comission < payout_tax_min) {
            comission = payout_tax_min;
        } else if(newState === 0) {
            comission = 0;
        }

        //Расчет ндфл
        let ndfl = Math.round(newState*payout_self_employed_tax_percent)/100;
        if(ndfl < payout_self_employed_tax_min) {
            ndfl = payout_self_employed_tax_min;
            minNdflText = payout_self_employed_tax_min;
        } else if(newState === 0) {
            ndfl = 0;
            minNdflText = null;
        }

        if(user_type) {
            ndfl = 0;
            minNdflText = null;
        }

        if(newState > (comission + ndfl)) {
            willWithdraw = newState - (comission + ndfl);
        }

        this.setState({
            withdrawMoney:{
                ...this.state.withdrawMoney,
                ndfl: ndfl || 0,
                amount: newState || 0,
                comission: comission || 0,
                minNdflText,
                willWithdraw,
            }
        })
    }

    cashOutHandleSmsCode(value) {
        this.setState({
            withdrawMoney: {
                ...this.state.withdrawMoney,
                code: value
            }
        });
    }

    handleOnChangeSimple(parent, field, value) {
        this.setState({
            [parent]: {
                ...this.state[parent],
                [field]: value
            }
        }, () => this.updateAmount(field));
    }

    updateAmount(field) {
        if(field === 'user_type') {
            this.cashOutHandleAmount(this.state.withdrawMoney.amount);
        }
    }

    validateFields(obj) {
        if(!obj) return {};
        const {withdrawMoney:{willWithdraw, comission, amount}} = this.state;
        let errors = {};

        for(let key in obj) {
            if((obj[key] || '').toString().trim() === '') {
                errors[key] = "Обязательное поле"
            }
            else if(key === 'amount' && willWithdraw === 0) {
                errors['amount'] = `Нельзя вывести ${amount} руб.`
            }
        }
        return errors;
    }

    cashOutConfirm() {
        const {
            amount, step, fio, inn, user_type, card_number, willWithdraw,
            code, payOutData, isFetching, payment_type} = this.state.withdrawMoney;

        if(isFetching) return false;

        let errors = this.validateFields({
            amount, user_type, card_number, fio, inn, payment_type, willWithdraw
        });
        let errorLength = Object.keys(errors).length;

        if(step === 2 && (code || '').toString().trim() === '') return false;

        this.setState({
            withdrawMoney: {
                ...this.state.withdrawMoney,
                field_errors: errors,
                isFetching: errorLength ? false : true,
            }
        });

        if(errorLength) return false;
        
        let params = {
            fio, inn, amount, card_number, payment_type,
            user_type: user_type ? 1 : 0
        };

        if(step === 1) {
            this.props.payOut(
                params,
                (data) => this.cashOutStepFirstSuccess(data),
                () => this.cashOutStepFirstError(),
            )
            return false;
        }

        if(step === 2) {
            this.props.payOutConfirm(
                {...payOutData, code},
                (data) => this.cashOutStepSecondSuccess(data),
                (error) => this.cashOutStepSecondError(error),
            )
            return false;
        }
    }

    cashOutStepFirstSuccess(data) {
        // console.log("first step success", data);

        this.setState({
            withdrawMoney: {
                ...this.state.withdrawMoney,
                payOutData: data,
                step: 2,
                isFetching: false,
            }
        });
    }

    cashOutStepFirstError() {
        this.setState({
            withdrawMoney: {
                ...this.state.withdrawMoney,
                type:'error',
                isFetching:false
            },
        })
    }

    cashOutStepSecondSuccess(data) {
        if(data.status) {
            this.props.getCurrentUserSuccess({
                balance_contractor: (this.props.session.currentUser.balance_contractor - parseFloat(data.amount)) || 0
            });
        }

        this.setState({
            withdrawMoney: {
                ...this.state.withdrawMoney,
                type: data.status ? 'success' : 'error',
                isFetching: false,
                confirmData: data,
            }
        });
    }

    cashOutStepSecondError(error) {
        this.setState({
            withdrawMoney: {
                ...this.state.withdrawMoney,
                isFetching: false,
                type: 'error',
                confirmData: {non_field_errors: error || ''},
            }
        });
    }

    cashOutCancel() {
        this.setState({
            withdrawMoney: {
                isFetching:false,
                type:'default',
                step: 1,
                code: '',
                show:false,
                comission: 0,
                willWithdraw: 0,
                user_type: true,
            }
        })
    }

    cashInUserOpen() {
        this.setState({
            putBalanceIndividual: {
                ...this.state.putBalanceIndividual,
                show: true
            }
        });
    }

    cashInUserCancel() {
        this.setState({
            putBalanceIndividual: {
                ...this.state.putBalanceIndividual,
                show: false
            }
        });
    }

    cashInUserOnChange(value, field) {
        this.setState({
            putBalanceIndividual:{
                ...this.state.putBalanceIndividual,
                [field]: value,
            }
        })
    }

    cashInUserConfirm() {
        const {amount} = this.state.putBalanceIndividual;
        const { id } = this.props.session.currentUser;
        
        if(!amount || myToString(amount) === '') return false;

        let formData = new FormData();
        formData.append("amount", this.state.putBalanceIndividual.amount);
        formData.append("user_id", id);
        this.setState({
            putBalanceIndividual: {
                ...this.state.putBalanceIndividual,
                isFetching: true
            }
        })
        axios.post(
            `${window.siteUrl}/api/v1/make-payment/`,
            formData,
            {headers: getHeader()}
        )
        .then(function (response) {
            this.setState({
                putBalanceIndividual: {
                    ...this.state.putBalanceIndividual,
                    show: false,
                    html: response.data,
                    isFetching: false
                }
            }, () => {
                // this.htmlForm.getElementsByTagName("button")[0].click();
                // console.warn("html", this.htmlForm);
                this.htmlForm.querySelector("form").submit();
            });
        }.bind(this))
        .catch(function (error) {
            console.error("TopUpBalance error-", error);

            this.setState({
                putBalanceIndividual:{
                    ...this.state.putBalanceIndividual,
                    show: false,
                    isFetching: false
                }
            });
        });
    }

    render() {

        return (
            
                <div className="user-container content">
                    <div ref={(node)=>{ this.htmlForm = node }} hidden={true} dangerouslySetInnerHTML={{ __html: this.state.putBalanceIndividual.html }} />
                    
                    <BlacklistModal
                        inputProps={this.state.removeBlacklistModal}
                        onConfirm={() => this.confirmRemove()}
                        onCancel={() =>  this.closeRemove()}
                    />

                    <PromocodeModal
                        inputProps={this.state.activatePromo}
                        promocodeClose={() => this.promocodeClose()}
                        promocodeConfirm={() => this.promocodeConfirm()}
                        handlePromocode={(value) => this.handlePromocode(value)}
                    />

                    <CashInUserModal
                        inputProps={this.state.putBalanceIndividual}
                        cashInUserConfirm={() => this.cashInUserConfirm()}
                        cashInUserCancel={() => this.cashInUserCancel()}
                        cashInUserOnChange={(value, field) => this.cashInUserOnChange(value, field)}
                    />

                    <CashOutUserModal
                        inputProps={this.state.withdrawMoney}
                        onCancel={() => this.cashOutCancel()}
                        onConfirm={() => this.cashOutConfirm()}
                        orderList={this.state.orderList}
                        loadMoreOrders={(next) => this.getOrderList(next)}
                        handleSmsCode={(value) => this.cashOutHandleSmsCode(value)}
                        is_email_confirmed={this.props.session.currentUser.is_email_confirmed}
                        handleOnChangeSimple={(field, value) => this.handleOnChangeSimple('withdrawMoney', field, value)}
                    />

                    <LeftNavContent>
                        <h2 className="left-content__title" style={{marginBottom:"25px"}}>Личный кабинет</h2>

                        <div className="radios-slider big-radios-slider">
                            <NavLink exact className="radio active" to="/account">
                                <label htmlFor="option1">Физ. лицо</label>
                            </NavLink>
                            <NavLink className="radio" to="/account/entity">
                                <label htmlFor="option1">Юр. лицо</label>
                            </NavLink>
                        </div>

                        <ul className="menu-content-nav">
                            <NavLink exact to="/account">
                                Личные данные
                            </NavLink>
                            <NavLink to="/account/passport">
                                Паспортные данные
                            </NavLink>
                            <NavLink to={`/account/balance`}>
                                Баланс
                            </NavLink>
                            <NavLink to="/account/blacklist">
                                Черный список
                            </NavLink>
                            <NavLink to="/account/notificaions">
                                Оповещение
                            </NavLink>
                            <a href='#' onClick={this.onPromocodeClick.bind(this)}>Промокод</a>
                            <NavLink to="/account/settings">
                                Настройки заказов
                            </NavLink>
                            <NavLink to="/account/locations">
                                Местоположения
                            </NavLink>
                            <NavLink to="/account/social-network">
                                Социальные сети
                            </NavLink>
                            <a href="" onClick={(e) => this.props.showConfirm(e)}>
                                Выйти
                            </a>
                        </ul>
                    </LeftNavContent>
                    
                    <Switch>
                        <Route exact path="/account" component={PersonalData} />
                        <Route path="/account/passport" component={PassportData} />
                        <Route path="/account/blacklist" 
                            render={(props) => 
                                <BlackList
                                    {...props}
                                    onModalClick={this.onModalClick.bind(this)}
                                />
                            } 
                        />
                        <Route
                            path={`/account/balance`}
                            render={(props) =>
                                <Balance
                                    {...props}
                                    withdrawMoney={() => this.withdrawMoneyOpen()}
                                    cashInUserOpen={() => this.cashInUserOpen()}
                                    />
                                }
                            />
                        <Route path="/account/notificaions" component={Notificaions} />
                        <Route path="/account/settings" component={Settings} />
                        <Route
                            exact
                            path={`/account/locations`}
                            render={(props) =>
                                <Locations {...props} />
                                }
                            />
                        <Route path="/account/locations/create" component={LocationCreate} />
                        <Route path="/account/social-network" component={SocialNetwork} />
                    </Switch>
                 
                </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(
    mapStateToProps,
    {
        getCurrentUserSuccess,
        activatePromocode,
        payOutConfirm,
        addMoneyUser,
        payOut,
    }
)(Account);


// WEBPACK FOOTER //
// ./src/components/Account/AccountContainer.js